import UILayout from "components/layout/UILayout";
import { RouterLink } from "components/ui/Link";
import Tile from "components/ui/Tile";
import styled from "styled-components";
import { mediaMax, mediaMin } from "utils/theme";

export const Wrapper = styled(UILayout)`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

export const Header = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const CardWrapper = styled.div`
  position: relative;
  z-index: 1;

  width: 100%;
  padding: 0 48px;
  margin-bottom: -48px;

  filter: drop-shadow(0 4px 16px ${(props) => props.theme.colors.primary}20);

  pointer-events: none;

  ${mediaMax("md")} {
    padding: 0 16px;
    margin-bottom: -36px;
  }

  @media screen and (max-width: 360px) {
    padding: 0;
  }
`;

export const Card = styled.div`
  width: 100%;
  max-width: 360px;
  margin: 0 auto;

  pointer-events: all;

  ${mediaMax("md")} {
    width: calc(100% - 64px);
  }
`;

export const HeaderTile = styled(Tile)`
  position: relative;

  width: 100%;
  padding: 0;
  overflow: hidden;
`;

export const HeaderInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 60px 16px 16px;

  ${mediaMin("md")} {
    padding: 72px 24px 24px;
  }
`;

export const HeaderSpending = styled.div`
  position: relative;

  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 48px;
`;

export const HeaderSpendingDivider = styled.div`
  position: absolute;
  top: 0;
  left: -24px;

  width: 1.5px;
  height: 100%;
  background-color: ${(props) => props.theme.colors.text}22;
`;

export const HeaderSpendingItem = styled.div`
  position: relative;

  display: flex;
  flex-direction: column;
  gap: 12px;
  flex: 1 1 auto;

  &:first-child {
    ${HeaderSpendingDivider} {
      display: none;
    }
  }
`;

export const HeaderCtaWrapper = styled.div``;

export const IconButtonWrapper = styled.div`
  .fa-primary {
    fill: currentColor;
  }

  .fa-secondary {
    fill: ${(props) => props.theme.colors.accent};
    opacity: 0;

    transition: all ${(props) => props.theme.transitions.simple};
  }

  a,
  button {
    &:hover {
      color: ${(props) => props.theme.colors.primary} !important;

      .fa-secondary {
        opacity: 1;
      }
    }
  }
`;

export const HeaderSettingsLinkWrapper = styled(IconButtonWrapper)`
  position: absolute;
  right: 24px;
  top: 24px;

  ${mediaMax("md")} {
    right: 16px;
    top: 16px;
  }
`;

export const HeaderSettingsLink = styled(RouterLink)`
  display: flex;
  align-items: center;
  justify-content: center;
`;
